var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBottomIntroWaveBig(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 918,
    height: 422,
    viewBox: "0 0 918 422",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1002.1 14.4389C1002.1 14.4389 979.06 -21.3626 931.741 19.7839C899.726 47.6411 843.689 174.1 544.267 123.767C314 98.7976 402.502 189.765 5.72205e-05 133.798C25.8594 173.336 4.39747 178.274 0 203.315V513H1002.1V14.4389Z",
    fill: "#28388E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M728.803 117.856C728.803 117.856 635.412 139.589 499.432 92.4339C405 59.6871 317 164.798 317 164.798L178.5 159.798C178.5 159.798 420 4.79761 505.154 50.0577C505.154 50.0577 602.021 121.35 728.803 117.856Z",
    fill: "#28388E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottomIntroWaveBig);
export default __webpack_public_path__ + "static/media/bottom-intro-wave_big.e3ef2e4d3fb074eeb73fde33d9b2d1a0.svg";
export { ForwardRef as ReactComponent };